import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import light from '../themes';
import './styles/portallayout.css';


const theme = createMuiTheme(light);


class PortalLayout extends Component {

  constructor(props, context) {
    super(props);
    this.state = {}
  }


  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <div className="layout-portal-container">

          <Paper>
            <div className="layout-portal-content-container">
              {this.props.children}
            </div>
          </Paper>

        </div>
      </MuiThemeProvider>
    );
  }
}

PortalLayout.contextTypes = {
   router: PropTypes.object,
}

export default PortalLayout;



// WEBPACK FOOTER //
// ./src/layouts/PortalLayout.js